import React, { PropTypes } from 'react';
import ErrorContainer from '../../form/ErrorContainer';
import {List} from 'material-ui/List';
import {ListItem} from 'material-ui/List';
import Checkbox from 'material-ui/Checkbox';


class PlayersSelectList extends React.Component {
  static propTypes = {
    load: PropTypes.func,
    items: PropTypes.array,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    value: PropTypes.array,
    onChange: PropTypes.func.isRequired
  };

  componentDidMount() {
    this.props.load();
  }

  check(id) {
    if (this.props.disabled) return;
    let values = this.props.value || [];
    let itemIndex = values.indexOf(id);

    if (itemIndex === -1) {
      values.push(id);
    } else {
      values.splice(itemIndex, 1);
    }

    this.props.onChange(values);
  }

  isChecked(id) {
    let values = this.props.value || [];
    return values.indexOf(id) !== -1;
  }

  render() {
    let { loading, items = [], name, disabled } = this.props;

    return (
      <ErrorContainer id={`PlayersSelectList_${name}`} {...this.props}>
        {!loading
          ?
          <List>
            {items.map(({ id, name })=> (
              <ListItem
                key={id}
                label=""
                leftAvatar={<Checkbox
                  disabled={disabled}
                  style={{top: 16}}
                  checked={this.isChecked(id)}
                 />}
                primaryText={name}
                onClick={() => this.check(id)}
              />
            ))}
          </List>
          : <div>Loading...</div>
        }
      </ErrorContainer>
    );
  }
}

export default PlayersSelectList;



// WEBPACK FOOTER //
// ./src/components/Players/PlayersSelectList/PlayersSelectList.jsx